import React from "react";
import { Button, IconButton, Stack, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";

import { formatDate } from "utils/formatDate";

/**
 * Users table for the admin list define here
 */
const UsersTable = (users = [], methods = {}) => {
  const { navigate, copyToClipboard, offset = 0 } = methods;
  const { t } = useTranslation();

  const columns = [
    { field: "id", headerName: "#", width: 70 },
    {
      field: "category",
      headerName: t("fields.category"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: "fullName",
      headerName: t("fields.fullName"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: "WalletId",
      headerName: t("fields.WalletID"),
      minWidth: 250,
      flex: 1,
      renderCell: (props) => {
        const walletId = props.row.WalletId;

        if (!walletId) return <span>—</span>;

        return (
          <Stack direction="row" spacing={0.75} alignItems="center">
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {walletId}
            </span>
            <Tooltip title="Copy wallet ID" arrow>
              <IconButton
                size="small"
                onClick={() => copyToClipboard(walletId)}
                sx={{ p: 0.25 }}
              >
                <ContentCopyIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
    { field: "email", headerName: t("fields.email"), minWidth: 150, flex: 1 },
    {
      field: "verified",
      headerName: t("fields.verified"),
      width: 120,
      renderCell: (props) =>
        props.row.verified ? (
          <span style={{ color: "green" }}>Verified</span>
        ) : (
          <span style={{ color: "red" }}>Not Verified</span>
        ),
    },
    {
      field: "investor",
      headerName: t("fields.investor"),
      width: 110,
      renderCell: (props) =>
        props.row.investor ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>Not yet</span>
        ),
    },
    {
      field: "createdAt",
      headerName: t("fields.createdAt"),
      minWidth: 130,
      flex: 1,
    },
    {
      field: "actions",
      headerName: t("fields.actions"),
      minWidth: 170,
      renderCell: (props) => {
        const id = props.row._id;

        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => navigate(`/admin/user-details/${id}`)}
            sx={{
              borderRadius: "999px",
              textTransform: "none",
              px: 2,
              boxShadow: "none",
              background: "linear-gradient(135deg, #E60E10 0%, #ff6b4a 100%)",
              "&:hover": {
                boxShadow: "none",
                background: "linear-gradient(135deg, #cc0d0f 0%, #ff5b35 100%)",
              },
            }}
          >
            View Details
          </Button>
        );
      },
    },
  ];

  const rows =
    users.length === 0
      ? []
      : users.map((user, index) => ({
          id: offset + index + 1,
          fullName: user.name,
          WalletId: user.wallet,
          email: user.email,
          verified: user.isVerified,
          investor: user.isInvestor,
          createdAt: formatDate(user.createdAt),
          category: user.category,
          _id: user._id,
        }));

  return { rows, columns };
};

export default UsersTable;
